import React, { ReactElement, ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import { InfoCircleSvg } from 'pages/common/components/svgs/InfoCircleSvg';

import { Wrapper } from './TooltipWithIcon-styled-components';

interface TooltipProps {
  children: ReactNode;
  iconColor?: string;
  iconSize?: number;
}

export const TooltipIcon = ({
  children,
  iconColor,
}: TooltipProps) => {
  return (
    <Wrapper
      data-tooltip-id="react-tooltip"
      data-tooltip-html={renderToStaticMarkup(children as ReactElement)}
      tabIndex={0}
    >
      <InfoCircleSvg color={iconColor} />
    </Wrapper>
  );
};
